import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { Team } from 'modules/overlay-v2/domain/interfaces/game-info/state';
import { toast } from 'react-toastify';
import { fetchPassedEvents, resetGameInfo, syncGameInfo } from './actions';
import { GameInfoSliceState } from './game-info';

type ReducerBuilder = ActionReducerMapBuilder<GameInfoSliceState>;

function resetTeam(team: Team) {
  team.members = team.members?.map((member) => {
    return {
      ...member,
      qtyFoulsMatch: 0,
      qtyGoalsMatch: 0,
      qtyRedCardsMatch: 0,
      qtyYellowCardsMatch: 0,
    };
  });
  return team;
}

export function createSyncDataReducer(builder: ReducerBuilder) {
  builder.addCase(syncGameInfo.pending, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = true;
    state.error = undefined;
  });

  builder.addCase(syncGameInfo.fulfilled, (state, action) => {
    state.isSynchronize = true;
    state.isSynchronization = false;
    state.error = undefined;

    state.goals = action.payload.goals;
    state.fouls = action.payload.fouls;

    // TODO Сделать маппер
    const match = action.payload.gameInfo?.match;
    if (match) {
      state.match = {
        ...match,
        date: match.dateInfo.fullDate,
      };
    }

    const teams = action.payload.gameInfo?.teams;
    if (teams) {
      const first = teams.firstTeam;
      const second = teams.secondTeam;
      if (!first) {
        console.warn({ 'No first team': teams });
      } else if (!second) {
        console.warn({ 'No second team': teams });
      } else {
        state.teams = {
          first: { ...first },
          second: { ...second },
        };
      }
    }

    const organizer = action.payload.gameInfo?.organizer;
    if (organizer) {
      state.organizer = { ...organizer };
    }

    const championship = action.payload.gameInfo?.championship;
    if (championship) {
      state.championship = { ...championship };
    }

    console.debug({ event: 'data synchronized' });
  });

  builder.addCase(syncGameInfo.rejected, (state, action) => {
    state.isSynchronize = false;
    state.isSynchronization = false;
    state.error = action.payload as string;

    console.error('Failed to synchronize game info', action.error);
  });
}

export function createResetAllReducer(builder: ReducerBuilder) {
  builder.addCase(resetGameInfo, (state) => {
    state.isSynchronize = false;
    state.isSynchronization = false;

    state.goals = { first: 0, second: 0 };
    state.fouls = {};

    if (state.teams?.first.members) {
      state.teams.first = resetTeam(state.teams.first);
    }
    if (state.teams?.second.members) {
      state.teams.second = resetTeam(state.teams.second);
    }

    state.parsedEventsId = [];
  });
}

export function createFetchPassedEventsReducer(builder: ReducerBuilder) {
  builder.addCase(fetchPassedEvents.fulfilled, (state, action) => {
    state.parsedEventsId = action.payload;
  });

  builder.addCase(fetchPassedEvents.rejected, (state) => {
    toast.error('Не удалось загрузить прошедшие события');
  });
}
